import { motion } from "framer-motion";
import bgPattern from "./assets/bg-patternn.svg"; 
import img1 from "./assets/vessel.jpg";
import img2 from "./assets/ava.jpg";
import img3 from "./assets/cha.jpg";

const CapacityOperations = () => {
    const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

 const imageZoom = (direction = "right") => ({
    hidden: {
      opacity: 0,
      x: direction === "right" ? 80 : -80,
      scale: 1.05,
    },
    visible: {
      opacity: 1,
      x: 0,
      scale: 1,
      transition: { duration: 1, ease: "easeOut" },
    },
    hover: {
      scale: 1.05,
      transition: { duration: 0.4, ease: "easeInOut" },
    },
  });
    return (
<section className="relative w-full py-24 font-epilogue bg-[#F5F7F9] overflow-hidden">
      {/* Background Pattern */}
      <img
        src={bgPattern}
        alt="Background Pattern"
        className="absolute inset-0 w-full h-full object-cover opacity-40 pointer-events-none z-0"
      />

      <div className="relative max-w-[1200px] mx-auto px-6 lg:px-12 z-10">
        {/* Section Title */}
        <motion.h2
          className="text-3xl lg:text-4xl font-semibold text-center mb-20 text-gray-900"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
        >
          What is Operations Execution?
        </motion.h2>

        <div className="flex flex-col gap-28">
          {/* Row 1 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <motion.div
              className="flex flex-col text-left md:pr-12"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Vessel Changes
              </h3>
              <p className="text-gray-600 leading-relaxed text-base">
                In a dynamic environment, changes to vessel schedules at the
                last minute happen frequently. JIVIEWS offers re-planning and
                redeployment tools that help users adapt quickly and easily.
              </p>
            </motion.div>

            <motion.img
              src={img1}
              alt="Vessel Changes"
              className="rounded-2xl shadow-md w-full object-cover"
              variants={imageZoom("right")}
              initial="hidden"
              whileInView="visible"
              whileHover="hover"
              viewport={{ once: true }}
            />
          </div>

          {/* Row 2 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <motion.img
              src={img2}
              alt="Resource Availability"
              className="rounded-2xl shadow-md w-full object-cover order-2 md:order-1"
              variants={imageZoom("left")}
              initial="hidden"
              whileInView="visible"
              whileHover="hover"
              viewport={{ once: true }}
            />

            <motion.div
              className="flex flex-col text-left md:pl-12 order-1 md:order-2"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Resource Availability
              </h3>
              <p className="text-gray-600 leading-relaxed text-base">
                Last-minute cancellations and sick leave can disrupt work
                assignments — addressed effectively with JIVIEWS Swap and
                Replacement functions.
              </p>
            </motion.div>
          </div>

          {/* Row 3 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <motion.div
              className="flex flex-col text-left md:pr-12"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Equipment Changes
              </h3>
              <p className="text-gray-600 leading-relaxed text-base">
                Adding, replacing, or removing equipment is handled seamlessly,
                ensuring continuous operational flow.
              </p>
            </motion.div>

            <motion.img
              src={img3}
              alt="Equipment Changes"
              className="rounded-2xl shadow-md w-full object-cover"
              variants={imageZoom("right")}
              initial="hidden"
              whileInView="visible"
              whileHover="hover"
              viewport={{ once: true }}
            />
          </div>
        </div>
      </div>
    </section>
    );
};

export default CapacityOperations;